// extracted by mini-css-extract-plugin
export default {"background":"welcome_background__5zk3f","wrapper":"welcome_wrapper__Ti1tP","title":"welcome_title__sdPAG","inventia":"welcome_inventia__rP74p"};